"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.raf = raf;
exports.timeout = timeout;

function raf() {
  return new Promise(function (resolve) {
    return requestAnimationFrame(resolve);
  });
}

function timeout(timer) {
  return new Promise(function (res) {
    return setTimeout(function () {
      return raf().then(res);
    }, timer);
  });
}